/**
 * Centralized feature flag helpers.
 *
 * Flags are read from `process.env.REACT_APP_*` (CRA inlines these at build time).
 * Keep all flag reads behind these helpers so consumers never touch `process.env`
 * directly and behavior stays consistent across the app.
 */

/**
 * GL Monthly Summary UI rollout flag.
 *
 * When `false` (default): the new GL Summary sidebar entries are hidden and their
 * routes 404 back to the existing screens.
 * When `true`: all new GL Summary screens are visible and routable.
 */
export const isGLSummaryUIEnabled = (): boolean =>
  process.env.REACT_APP_USE_GL_SUMMARY_UI === "true";
/**
 * MirtaPBX call-linking UI rollout flag.
 *
 * When `false` (default): the call-linking UI (Call button, Calls tabs, Unlinked
 * Calls inbox, User-Extensions admin screen) is hidden and its routes 404 back to
 * the existing screens.
 * When `true`: all MirtaPBX call-linking screens are visible and routable.
 */
export const isMirtapbxCallLinkingEnabled = (): boolean =>
  process.env.REACT_APP_MIRTAPBX_CALL_LINKING === "true";
